<div #container class="hour-indicator-container">
  <div #indicator class="hour-indicator">
    <p #dateText class="b2"></p>
    <div #dropIndicator class="drop-indicator">
      <mat-icon svgIcon="back"></mat-icon>
    </div>
  </div>
</div>
